/**
 * The host adapter for the `workspace-add-people` client-side entity (ADR-040
 * Q12). The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId, holderId }`; the page that mounted an arche — the plugin
 * renderer, or the Arche Builder's preview — registers here the function that
 * draws ITS Add people sheet, and the executor reaches it by arche id (a
 * preview's is `preview_bsn_…`). An arche with no mounted page answers
 * ADD_PEOPLE_UNAVAILABLE.
 */

import type {
  AddPeopleSuggestedRole,
  WorkspaceAddPeopleHost,
  WorkspaceAddPeopleResult,
} from '@fias/client-entities';

export interface AddPeopleSheetRequest {
  holderId: string | null;
  workspaceId: string;
  role: AddPeopleSuggestedRole;
}

type SheetHandler = (request: AddPeopleSheetRequest) => Promise<WorkspaceAddPeopleResult>;

const handlers = new Map<string, SheetHandler>();

/** Called by the page that mounts an arche; returns the unregister function. */
export function registerAddPeopleSheet(archeId: string, handler: SheetHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const workspaceAddPeopleHost: WorkspaceAddPeopleHost = {
  async showAddPeopleSheet({ archeId, holderId, workspaceId, role }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: { code: 'ADD_PEOPLE_UNAVAILABLE', message: 'Adding people is not available here' },
      };
    }
    return handler({ holderId, workspaceId, role });
  },
};
